package org.braunequip.web.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.window
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.braunequip.web.components.forms.NeedQuoteForm
import org.braunequip.web.components.layouts.PageLayout
import org.braunequip.web.components.widgets.ServiceCard
import org.braunequip.web.components.widgets.ServiceCardContainer
import org.braunequip.web.styles.*
import org.braunequip.web.util.InputIDs
import org.braunequip.web.util.submitContact
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Page
@Composable
fun HomePage() {
    val sitePalette = ColorMode.current.toSitePalette() //Not needed yet, need to set values in SiteTheme.kt
    val scope = rememberCoroutineScope()

    PageLayout("Home") {


        //Hero Section
        Section(PageHeroContainer.toModifier().then(lineupBg.toModifier()).toAttrs()) {
            Row(Modifier.fillMaxSize(), horizontalArrangement = Arrangement.End) {
                Column(CallColumn.toModifier(), horizontalAlignment = Alignment.CenterHorizontally) {
                    Div(HeadlineTextStyle.toModifier().then(HeroAlign.toModifier()).toAttrs()) {
                        SpanText("For Hire Trucking, Logistics, and Equipment Contracting", Modifier.color(Colors.White))
                    }

                    Div(
                        SubheadlineTextStyle.toModifier().color(Colors.White).then(HeroAlign.toModifier()).toAttrs()) {
                        SpanText("Read the")
                        Link("#services", " Services Section", Modifier.color(Colors.LightGreen))
                        SpanText(" for more detailed information!")
                    }

                    val ctx = rememberPageContext()
                    Button(onClick = {
                        ctx.router.tryRoutingTo("#${InputIDs.QuoteForm.formName}")
                     }, modifier = RespButtonStyle.toModifier().then(CTAButtonStyle.toModifier())
                    , size = ButtonSize.LG) {
                        SpanText("Get A Quote!", Modifier.fontSize(1.3.cssRem))
                    }
                }
            }
        }

        //Services Section
        Section(ServiceContainerStyle.toAttrs()) {
            Row(Modifier, verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.Center) {
                H1(HeadlineTextStyle.toModifier()
                    .color(Colors.White)
                    .toAttrs{ id("services")}) { Text("Our Services") }
            }
            Div(ServiceCardContainer.toModifier()
                .classNames("container", "is-widescreen")
                .toAttrs()) {
                ServiceCard("gentrucking.jpg", "General Trucking", "Fleet of flatbed, lowboys, chip trailers, dump trailers, log trailers")
                ServiceCard("heavyequip.jpg", "Heavy Equipment Contracting", "Highly maintained equipment available for short and long term lease. Furnished with Operator as needed")
                ServiceCard("forestservice.jpg", "Forest Service & Cal Fire Contracting", "Hired Equipment contractor to assist Cal Fire, Forest Service, and FEMA in Natural Disasters")
                ServiceCard("pilotcar.jpg", "Pilot Car Services", "Affordable pilot car services available for hire or specialty loads servicing Redding and Surrounding areas")
                ServiceCard("empiregroup.jpg", "Freight Brokering", "Braun Equipment has partnered with Empire Group Unlimited, our affiliated freight brokerage, to seamlessly meet a wide range of customer needs beyond our own fleet.")
                ServiceCard("yardstorage.jpg", "Yard Storage", "Ability to offload and store equipment product in secured facility for customers")
                ServiceCard("dieselrepair.jpg", "Diesel Repair", "Mobile Commercial Truck and Trailer Repair, Close Proximity to Cottonwood Scales, Tire Repair, Electrical, Brakes, Diagnostics, Preventative Maintenance, Oil Changes, DOT Inspections, Engine Repair")
            }
        }

        //Our Partners
        Section(PartnersContainerStyle.toAttrs()) {
            Row(Modifier, verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.Center) {
                H1(HeadlineTextStyle.toModifier().color(Colors.Black).toAttrs()) { Text("Our Partners") }
            }
            Row(
                modifier = Modifier
                    .classNames("container", "is-widescreen")
                    .fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.Center
            ) {
                Img("autosocklogo.jpg", alt = "AutoSock Logo", PartnerImageStyle.toAttrs())
            }
        }

        Section(
            attrs = Modifier
                .padding(top = 2.cssRem, bottom = 6.cssRem)
                .fillMaxWidth()
                .backgroundColor(Colors.White)
                .toAttrs()
        ) {
            Column(
                modifier = Modifier
                    .id(InputIDs.QuoteForm.formName)
                    .width(min(1000.px, (100.percent - 1.cssRem)))
                    .margin(leftRight = autoLength),
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                H1(HeadlineTextStyle.toModifier().margin(bottom = 1.cssRem).color(Colors.Black).toAttrs()) { Text("Need A Quote?") }

                NeedQuoteForm(
                    onSubmit = {
                        scope.launch {
                            submitContact(it)
                            delay(2000)
                            window.location.reload()
                        }
                    }
                )
            }
        }
    }
}
